const DAY_MS = 24 * 60 * 60 * 1000;

export const AIRCRAFT_AVAILABILITY_CONTEXT_PERIOD_MARGIN_DAYS = 5;

export function parseDraftPeriodBoundary(value, endOfDay = false) {
    if (!value) {
        return null;
    }

    const text = String(value);
    const isoText = text.includes("T") ? text : `${text}T${endOfDay ? "23:59:59.999" : "00:00:00.000"}Z`;
    const timestamp = new Date(isoText).getTime();
    return Number.isFinite(timestamp) ? timestamp : null;
}

export function buildDraftPeriodTimeWindow(draft, { marginDays = 0 } = {}) {
    const start = parseDraftPeriodBoundary(draft?.period_start, false);
    const end = parseDraftPeriodBoundary(draft?.period_end, true);
    if (start === null && end === null) {
        return null;
    }

    const resolvedStart = start ?? end - DAY_MS;
    const resolvedEnd = end ?? start + DAY_MS;
    if (!Number.isFinite(resolvedStart) || !Number.isFinite(resolvedEnd) || resolvedEnd <= resolvedStart) {
        return null;
    }

    const margin = Math.max(Number(marginDays) || 0, 0) * DAY_MS;
    return {
        start: new Date(resolvedStart - margin).toISOString(),
        end: new Date(resolvedEnd + margin).toISOString(),
    };
}
